<template>
  <div :class="$style.confirm">
    <h1 :class="$style.confirm__title">ページ移動の確認</h1>
    <p :class="$style.confirm__description">
      このページから移動してもよろしいですか？<br />
      変更内容は破棄されます。
    </p>
    <div :class="[$style.confirm__buttonArea, $style.buttons]">
      <FlatButton
        :class="$style.buttons__button"
        variant="secondary"
        size="medium"
        @click="$emit('cancel')"
      >
        このページに留まる
      </FlatButton>
      <FlatButton
        variant="caution"
        size="medium"
        :class="$style.buttons__button"
        @click="$emit('confirm')"
      >
        変更内容を保存せず移動
      </FlatButton>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

export default defineComponent({
  name: 'SettingPageBeforeLeaveConfirmation',
  components: {
    FlatButton,
  },
})
</script>

<style lang="scss" module>
.confirm {
  padding: 40px;
  border-radius: $border-radius-v2-base;

  &__title {
    font-size: 24px;
    font-weight: bold;
  }

  &__description {
    margin-top: 24px;
    font-size: 16px;
    line-height: 24px;
  }

  &__buttonArea {
    margin-top: 32px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;

    &__button {
      &:nth-child(n + 2) {
        margin-left: 24px;
      }
    }
  }
}

.link {
  display: inline-flex;
  align-items: center;
  color: $color-text-and-object-accent-primary;
  font-size: 14px;

  &:hover {
    color: $color-text-and-object-accent-primary;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
